import { useQuery } from "@tanstack/react-query";

import { getFootprintingCropPurchasersByFarmId, getFootprintingCropPurchasersByFarmIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_PURCHASERS } from "consts";

export const useGetFootprintingCropPurchasers = (farmId: string) => {
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingCropPurchasersByFarmIdAdmin : getFootprintingCropPurchasersByFarmId;

  return useQuery({
    queryKey: [FOOTPRINTING_CROP_PURCHASERS, farmId, isAdmin],
    queryFn: () => queryFn(farmId),
    enabled: !!farmId,
  });
};
